var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('paginated-content',{attrs:{"items":_vm.quizzes,"perPage":_vm.pageSize},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var displayItems = ref.displayItems;
return [_c('div',{staticClass:"columns"},_vm._l((displayItems),function(quiz,index){return _c('div',{key:index,staticClass:"column is-half"},[_c('quiz-item',{attrs:{"quiz":quiz}})],1)}),0)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }